import lazyPages from "../lazy-loading";

const dashboardRoutesLazy = [
  { path: "", element: <lazyPages.overview /> },
  {
    path: "bookings",

    children: [
      { path: "", element: <lazyPages.reservations /> },
      // change the name of the component meaningfully
      {
        path: ":bookingId",
        element: <lazyPages.singleReservation />,
      },

      // not yet implemented , change later
      { path: "cancel", element: <lazyPages.reservationCancel /> },
      {
        path: "confirm-cancellation",
        element: <lazyPages.confirmCancellation />,
      },
    ],
  },

  {
    path: "reviews",
    children: [
      { path: "", element: <lazyPages.reviews /> },
      {
        path: "write",
        exact: true,
        element: <lazyPages.WriteReview />,
      },
      {
        path: "edit/:reviewId",
        exact: true,
        element: <lazyPages.EditReview />,
      },
    ],
  },

  {
    path: "payments",
    element: <lazyPages.payment />,
  },
  {
    path: "wishlist",
    element: <lazyPages.wishlist />,
  },

  {
    path: "messages",
    element: <lazyPages.Messages />,
  },

  {
    path: "notifications",
    element: <lazyPages.notification />,
  },
  {
    path: "profile/edit",
    element: <lazyPages.editProfile />,
  },
  // routes not used yet
  // { path: "current-offers", element: <lazyPages.currentOffers /> },
];

export default dashboardRoutesLazy;
